/* global axios */
import ApiClient from '../ApiClient';

// FAQ (Ai::Response) — quando o admin anexa midia (image/video/audio/pdf),
// o body precisa virar multipart/form-data pra subir o File via
// ActiveStorage (`has_one_attached :media` no model). Sem media, mantemos
// o POST/PUT como JSON puro (comportamento atual).
const hasMediaFile = payload =>
  payload && payload.response && payload.response.media instanceof File;

const buildFormData = ({ response }) => {
  const fd = new FormData();
  Object.entries(response).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (value instanceof File) {
      fd.append(`response[${key}]`, value);
    } else if (typeof value === 'boolean') {
      fd.append(`response[${key}]`, value ? 'true' : 'false');
    } else {
      fd.append(`response[${key}]`, value);
    }
  });
  return fd;
};

class StudioResponse extends ApiClient {
  constructor() {
    super('ai/responses', { accountScoped: true });
  }

  get({ page, agentId, documentId, status } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        agent_id: agentId,
        document_id: documentId,
        status,
      },
    });
  }

  create(data) {
    if (!hasMediaFile(data)) return super.create(data);

    return axios.post(this.url, buildFormData(data), {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, data) {
    if (!hasMediaFile(data)) return super.update(id, data);

    return axios.put(`${this.url}/${id}`, buildFormData(data), {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new StudioResponse();
